window._ = require('lodash');

try {
    window.$ = window.jQuery = require('jquery');
    window.toastr = require('toastr');
    window.Swiper = require('swiper/bundle').default;
    window.GLightbox = require('glightbox');
    window.AOS = require('aos');
    AOS.init();
    
} catch (e) {}